<template>
    <div class="step-six-container">
        <div class="title-container">
            <span class="title">
                {{ $t('intervention.summary.title') }}
            </span>
        </div>
        <div class="summary-container">
            <StepSummary @edit="editStep(1)" :title="$t('intervention.bar.site')">
                <span>
                    {{ site?.bureauDistributeur ?? '' }}
                </span>
            </StepSummary>
            <StepSummary @edit="editStep(2)" :title="$t('intervention.bar.type')">
                <div class="step-container">
                    <p>
                        {{ `${$t('intervention.summary.type')} ${type.libelle}` }}
                    </p>
                    <p>
                        {{ `${$t('intervention.summary.delai')} ${delai.libelle}` }}
                    </p>
                    <p v-if="dateAutre">
                        {{ `${$t('intervention.summary.date')} ${dateAutre}` }}
                    </p>
                </div>
            </StepSummary>
            <StepSummary @edit="editStep(3)" :title="$t('intervention.bar.equipement')">
                {{ equipement?.libelle ?? $t('intervention.summary.noEquipement') }}
            </StepSummary>
            <StepSummary @edit="editStep(4)" :title="$t('intervention.bar.object')">
                <div class="step-container">
                    <p>
                        {{ objet }}
                    </p>
                    <p>
                        {{ description }}
                    </p>
                </div>
            </StepSummary>
            <StepSummary @edit="editStep(5)" :title="$t('intervention.bar.recurrence')">
                <div class="step-container">
                    <p v-if="recurrente">
                        {{ $t('intervention.summary.recurrent') }}
                    </p>
                    <p>
                        {{ $t('intervention.summary.contactSurSite') }}
                    </p>
                    <p>
                        {{ $t('intervention.summary.firstname.lastname') }} {{ `${contactSurSite.firstname} ${contactSurSite.lastname.toUpperCase()}` }}
                    </p>
                    <p v-if="contactSurSite.telephoneMobile">
                        {{ $t('intervention.summary.phone.mobile') }} {{ contactSurSite.telephoneMobile }}
                    </p>
                    <p v-if="contactSurSite.telephoneFixe">
                        {{ $t('intervention.summary.phone.fixe') }} {{ contactSurSite.telephoneFixe }}
                    </p>
                    <div v-if="contactsSuivi.length > 0" class="step-container">
                        <p>
                            {{ $t('intervention.summary.followBy') }}
                        </p>
                        <div v-if="contactsSuivi?.length > 1">
                            <div v-for="contactSuivi in contactsSuivi" :key="contactSuivi.email" class="step-container multiple-contact">
                                <p>
                                    {{ `${contactSuivi.firstname} ${contactSuivi.lastname} ${contactSuivi.email}` }}
                                </p>
                            </div>
                        </div>
                        <div v-else>
                            <div v-for="contactSuivi in contactsSuivi" :key="contactSuivi.email" class="step-container">
                                <p>
                                    {{ $t('intervention.summary.firstname.lastname') }} {{ `${contactSuivi.firstname} ${contactSuivi.lastname}` }}
                                </p>
                                <p>
                                    {{ $t('intervention.summary.email') }} {{`${contactSuivi.email}`}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </StepSummary>
        </div>
    </div>
    <WaitingModal :text="$t('intervention.request.pending')" v-if="loading" />
    <SuccessModal @cancel="exit" v-if="success" :subtitle="$t('intervention.success.subtitle')" :title="response" />
</template>

<script>
import StepSummary from '@/components/ui-components/StepSummary.vue';
import SuccessModal from '@/components/ui-components/SuccessModal.vue';
import WaitingModal from '@/components/ui-components/WaitingModal.vue';
import { defineComponent } from 'vue';
import { INTERVENTION } from '../store/mutation-types';

export default defineComponent({
    components: { StepSummary, SuccessModal, WaitingModal },
    beforeMount() {
        this.$store.state.demandeInterventionModuleState.success = false;
    },
    methods: {
        editStep(step) {
            this.$store.commit(INTERVENTION.SET_STEP, step);
        },
        exit() {
            this.$store.commit(INTERVENTION.RESET_INTERVENTION);
            this.$router.replace('/dashboard');
        },
    },
    computed: {
        site() {
            return this.$store.getters.getInterventionSiteValue;
        },
        type() {
            return this.$store.getters.getInterventionTypeValue;
        },
        delai() {
            return this.$store.getters.getInterventionDelaiValue;
        },
        dateAutre() {
            return this.$store.getters.getInterventionDateAutreValue;
        },
        equipement() {
            return this.$store.getters.getInterventionEquipementValue;
        },
        objet() {
            return this.$store.getters.getInterventionObjetValue;
        },
        description() {
            return this.$store.getters.getInterventionDescriptifValue;
        },
        recurrence() {
            return this.$store.getters.getInterventionRecurrenteValue;
        },
        contactSurSite() {
            return this.$store.getters.getInterventionContactSurSiteValue;
        },
        contactsSuivi() {
            return this.$store.getters.getInterventionContactsValue;
        },
        recurrente() {
            return this.$store.getters.getInterventionRecurrenteValue;
        },
        loading() {
            return this.$store.getters.getInterventionLoading;
        },
        success() {
            return this.$store.getters.getIntervenTionRequestSuccess;
        },
        response() {
            return this.$t('intervention.success.title', {
                idIntervention: this.$store.getters.getInterventionResponse.id,
            });
        },
    },
});
</script>

<style scoped>
.step-six-container {
    padding: 24px;
    height: calc(89.9vh - 200px);
    overflow-y: auto;
    background-color: var(--white);
    border-radius: 4px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.title-container {
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-medium);
    color: var(--color-principal);
    margin-bottom: 16px;
}
.step-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.summary-container {
    display: flex;
    gap: 9px;
    flex-direction: column;
}
p {
    overflow: hidden;
    text-overflow: ellipsis;
}
.multiple-contact{
    padding-bottom: 10px;
}
</style>
